import { config } from '../config/env';

/**
 * Lista paginata risorse admin (`/services/admin/resource/:name`).
 * Stessa semantica usata da GenericListComponentTanStack.
 */
export type AdminResourceListResult = {
  rows: unknown[];
  totalRecords: number;
  totalPages: number;
};

export async function fetchAdminResourcePage(
  resourceName: string,
  page: number,
  pageSize: number,
  query?: string
): Promise<AdminResourceListResult> {
  const base = config.API_URL;
  let url = `${base}/services/admin/resource/${encodeURIComponent(
    resourceName
  )}?page=${page}&size=${pageSize}`;
  if (query != null && query.trim().length > 0) {
    url += `&query=${encodeURIComponent(query.trim())}`;
  }

  const response = await fetch(url, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(`HTTP ${response.status}: ${response.statusText}`);
  }

  const result: Record<string, unknown> = await response.json();

  let rows: unknown[] = [];
  if (result.data != null) {
    const d = result.data;
    rows = Array.isArray(d) ? d : [];
  } else if (Array.isArray(result)) {
    rows = result;
  }

  let totalRecords = 0;
  const pagination = result.pagination as
    | { totalRecords?: number; totalPages?: number }
    | undefined;
  if (pagination && typeof pagination.totalRecords === 'number') {
    totalRecords = pagination.totalRecords;
  } else if (typeof result.totalRecords === 'number') {
    totalRecords = result.totalRecords;
  } else if (typeof result.total === 'number') {
    totalRecords = result.total;
  } else {
    totalRecords = Array.isArray(rows) ? rows.length : 0;
  }

  const apiTotalPages =
    pagination && typeof pagination.totalPages === 'number'
      ? pagination.totalPages
      : Math.max(1, Math.ceil(totalRecords / pageSize));

  return {
    rows,
    totalRecords,
    totalPages: Math.max(1, apiTotalPages),
  };
}
